export default __webpack_public_path__ + "static/media/phone-in-hand--white.fcdd4d5d.svg";